
import Hero from '../Hero'
import ValuePropositions from 'components/ckan/ValuePropositions.jsx'
import Features from 'components/ckan/Features.jsx'
import Contact from 'components/ckan/Contact.jsx'
import Contact2 from 'components/ckan/Contact2.jsx'
import Numbers from '../Numbers.jsx'
import Faq from 'components/ckan/hosting/Faq.jsx'


export default function Index() { 
  const featured = [
  {
    title: "Theming",
    text: "Enjoy flexible theming options, from simple brand customisation to fully bespoke user interfaces.",
    icon: "/assets/icons/stationery.json",
  },
    {
    title: "Cloud Storage",
    text: "Ensure maximum scalability, redundancy and efficiency with cloud-based file storage.",
    icon: "/assets/icons/cloud-network.json",
  },
  {
    title: "Harvesters",
    text: "Get the right data quickly with finely-tuned, scalable harvesters for workloads large and small.",
    icon: "/assets/icons/seeding.json",
  },
  {
    title: "Support Package",
    text: "Get reliable answers quickly with on-demand support from the CKAN and data management experts.",
    icon: "/assets/icons/first-aid-kit.json",
  },
  {
    title: "3rd party CMS Integration",
    text: "Design compelling user experiences by seamlessly integrating your data and content.",
    icon: "/assets/icons/copy.json",
  },
  {
    title: "SEO Optimization",
    text: "Secure traffic for your data with maximum search engine crawlability and discoverability.",
    icon: "/assets/icons/analytical-skill.json",
  },
    {
    title: "Authorization",
    text: "Use the systems you’re used to through optional integration with existing authentication and authorization systems.",
    icon: "/assets/icons/key.json",
  },
  {
    title: "Data Store",
    text: "Effortlessly store and scale your data using SQL and noSQL solutions, with no limitations or restrictions.",
    icon: "/assets/icons/database.json",
  },
] 

const values= [
  {
    title: "One-Click Setup",
    text: "Get CKAN instances up and running in minutes.",
  },
    {
    title: "On our cloud or yours",
    text: "Opt to have us manage your instances at no extra cost.",
  },
    {
    title: "Free trial included",
    text: "Receive a trial instance now, no payment required.",
  },
      {
    title: "Data portability",
    text: "Move data seamlessly from one CKAN provider to another, whether that’s from an old provider to us or vice versa.",
  },
        {
    title: "Secure & Scalable",
    text: "Experience responsive, extensible infrastructure with a proactive security stance.",
  },
          {
    title: "Flexibile & Affordable",
    text: "Choose a plan that works for your specific needs and budget, and upgrade or downgrade as necessary.",
  },
]

const numbers = [
  {
    number: "500+",
    title: "Projects completed",
  },
    {
    number: "15M+",
    title: "Datasets",
  },
    {
    number: "10PB+",
    title: "Data served",
  },
    {
    number: "99.99%",
    title: "Guaranteed uptime",
  },
]
  return (
    <div className="flex flex-wrap justify-center">
      <div className="max-w-7xl w-full">
        <Hero 
        topTitle="CKAN Hosting"
        title="Managed CKAN in our cloud or yours. Take the hassle out of hosting."
        subtitle="Reliable, easy hosting from CKAN’s creators. With over a decade’s experience, we make managing CKAN simple." 
        ctaOffer="See other CKAN services"
        ctaUrl="/solutions/ckan#services"/>
        <Numbers numbers={numbers} />
        <ValuePropositions topTitle="Quick and reliable cloud solutions" title="Enjoy fast and easy CKAN setup with our scalable and secure hosting solutions." valuePropositions={values}/>
      </div>
      <Features topTitle="Hassle-free CKAN hosting" title="You'll never have to worry about data loss thanks to our automated backup and restore functionality, and our 24/7 support and maintenance ensure that you have the expert assistance you need whenever you need it." featuredItems={featured}/>
      <div className="max-w-7xl w-full">
        <Faq />
      </div>
        <Contact />
        <div className="md:hidden">
          <Contact2 />
        </div>
    </div>
  )
}